const MAX_IMG_SIZE = 2097152; // +-2MB
const ACCEPTED_IMG_EXTENSIONS = ['.jpg', '.jpeg', '.png'];
const DEFAULT_AVATAR = 'https://avatar.stockbit.com/placeholders/S.png';
const NAVIGATION_ITEMS = [
  {
    label: 'Public Profile',
    value: 'public-profile',
    icon: 'icon-securities_account_publicprofile',
    url: '/account',
  },
  {
    label: 'Preferences',
    value: 'preferences',
    icon: 'icon-profile_location',
    url: '/preferences',
  },
  {
    label: 'Password',
    value: 'password',
    icon: 'icon-securities-lock',
    url: '/password',
  },
  {
    label: 'Notification',
    value: 'notification',
    icon: 'icon-toolbar_bell',
    url: '/notification',
  },
  {
    label: 'Link Account',
    value: 'link-account',
    icon: 'icon-link-chain',
    url: '/integration',
  },
  {
    label: 'Privacy',
    value: 'privacy',
    icon: 'icon-user-privacy',
    url: '/privacy',
  },
  {
    label: 'Share Trade',
    value: 'sharetrade',
    icon: 'icon-sync-contact',
    url: '/sharetrade',
  },
  {
    label: 'Blocked List',
    value: 'blocked-list',
    icon: 'icon-user-block',
    url: '/blocked',
  },
  {
    label: 'Delete Account',
    value: 'delete-account',
    icon: 'icon-cancel_circle',
    url: '/delete',
  },
];

const INDONESIA_CITY_LIST = [
  'Aceh',
  'Ambon',
  'Banjarmasin',
  'Bali',
  'Bandar Lampung',
  'Banten',
  'Bengkulu',
  'Gorontalo',
  'Jambi',
  'Jayapura',
  'Kendari',
  'Kupang',
  'Makassar',
  'Mamuju',
  'Manado',
  'Manokwari',
  'Mataram',
  'Padang',
  'Palangkaraya',
  'Palembang',
  'Palu',
  'Pangkal Pinang',
  'Pekanbaru',
  'Pontianak',
  'Samarinda',
  'Semarang',
  'Sofifi',
  'Tanjung Pinang',
  'Tanjung Selor',
];

const INDONESIA_PREFERRED_CITY_LIST = [
  'DKI Jakarta',
  'Surabaya',
  'Bandung',
  'Yogyakarta',
];

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const SUCCESS_CONTENT = {
  PASSWORD: 'Password Sudah Diubah',
  EMAIL: 'Email Kamu Sudah Diubah',
  PHONE: 'Nomor Hp Kamu Sudah Diubah',
};

const PROGRESS_STATUS_ENUM = {
  no_amend: 1,
  verification: 2,
  in_progress: 3,
  rejected: 4,
};

const WORDING_FORMAT_EMAIL_WRONG = 'Email yang kamu masukkan tidak valid';

const SHARE_TRADE_PREVIEW = {
  text: 'Order Buy BBCA',
  symbol: 'BBCA',
  order_type: 'ORDER_TYPE_BUY',
  status: 'ORDER_STATUS_OPEN',
  updated_status: 'UPDATED_STATUS_UNSPECIFIED',
  price: 'Rp3,930',
  updated_price: '',
  parent_order_id: 'XL1205922VspdLUJrOr7',
  order_time: '2024-06-13T02:30:00Z',
  label: 'LABEL_UNSPECIFIED',
  is_show_value: false,
  qty: 0,
  updated_qty: 0,
  total_investment: 'Rp3,930,000',
  is_amend_lot: false,
};

export {
  MAX_IMG_SIZE,
  DEFAULT_AVATAR,
  NAVIGATION_ITEMS,
  INDONESIA_CITY_LIST,
  INDONESIA_PREFERRED_CITY_LIST,
  MONTHS,
  SUCCESS_CONTENT,
  ACCEPTED_IMG_EXTENSIONS,
  PROGRESS_STATUS_ENUM,
  WORDING_FORMAT_EMAIL_WRONG,
  SHARE_TRADE_PREVIEW,
};
